import { render } from "./DialogParcela.vue?vue&type=template&id=5c3c2fcf&scoped=true"
import script from "./DialogParcela.vue?vue&type=script&lang=js"
export * from "./DialogParcela.vue?vue&type=script&lang=js"

import "./DialogParcela.vue?vue&type=style&index=0&id=5c3c2fcf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3c2fcf"]])

export default __exports__